<template>
	<div class="login-page">

		<!-- Panel gauche : Branding + image -->
		<div class="brand-panel">
			<div class="brand-overlay"></div>
			<div class="brand-content">

				<img
					src="../assets/cez-logo-light.png"
					alt="CEZ Fitness"
					class="brand-logo"
				/>

				<div class="brand-body">
					<div class="brand-accent-bar"></div>
					<h1 class="brand-headline">BIENVENUE<br />AU</h1>
					<p class="brand-club-name">CEZ FITNESS CLUB</p>
					<p class="brand-tagline">
						Transformez votre corps.<br />Dépassez vos limites.
					</p>

					<ul class="brand-features">
						<li>
							<v-icon color="#ef5350" size="16">mdi-check-circle</v-icon>
							Suivi d'entraînement personnalisé
						</li>
						<li>
							<v-icon color="#ef5350" size="16">mdi-check-circle</v-icon>
							Programmes conçus par des experts
						</li>
						<li>
							<v-icon color="#ef5350" size="16">mdi-check-circle</v-icon>
							Communauté soudée et motivée
						</li>
					</ul>
				</div>

				<div class="brand-footer">
					<div class="brand-footer-bar"></div>
					<p class="brand-footer-text">Rejoignez l'élite sportive</p>
				</div>

			</div>
		</div>

		<!-- Panel droit : Formulaire -->
		<div class="form-panel">
			<div class="form-panel-inner">

				<div class="form-logo-wrap">
					<img src="../assets/cez-logo.png" alt="CEZ Fitness" class="form-logo" />
				</div>

				<SignIn @changeForm="changeForm()" :formShow="signInShow" />
				<SignUp @changeForm="changeForm()" :formShow="signUpShow" />

			</div>
		</div>

	</div>
</template>

<script>
import SignIn from "../components/Account/SignIn.vue";
import SignUp from "../components/Account/SignUp.vue";
export default {
	data() {
		return {
			signUpShow: false,
			signInShow: true,
		};
	},
	components: { SignIn, SignUp },
	methods: {
		changeForm() {
			this.signInShow = !this.signInShow;
			this.signUpShow = !this.signUpShow;
		},
	},
};
</script>

<style scoped>
.login-page {
	display: flex;
	min-height: 100vh;
	font-family: Montserrat, sans-serif;
}

/* ─── Panel gauche : Branding ─── */

.brand-panel {
	position: relative;
	flex: 0 0 56%;
	background-image: url("../assets/muscle2.jpg");
	background-size: cover;
	background-position: center top;
	display: flex;
	align-items: stretch;
}

.brand-overlay {
	position: absolute;
	inset: 0;
	background: linear-gradient(
		148deg,
		rgba(6, 8, 30, 0.95) 0%,
		rgba(130, 12, 12, 0.58) 50%,
		rgba(6, 8, 30, 0.92) 100%
	);
}

.brand-content {
	position: relative;
	z-index: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 52px 58px;
}

.brand-logo {
	width: 88px;
	margin-bottom: 52px;
}

.brand-body {
	flex: 1;
}

.brand-accent-bar {
	width: 50px;
	height: 5px;
	background: linear-gradient(to right, #ef5350, #1565c0);
	border-radius: 3px;
	margin-bottom: 28px;
}

.brand-headline {
	font-family: Megatron, Montserrat, sans-serif;
	font-size: 4.2rem;
	font-weight: 900;
	color: #ffffff;
	line-height: 1.02;
	letter-spacing: 4px;
	margin: 0 0 10px;
}

.brand-club-name {
	font-size: 0.72rem;
	font-weight: 700;
	color: #ef9a9a;
	letter-spacing: 5px;
	text-transform: uppercase;
	margin: 0 0 26px;
}

.brand-tagline {
	font-size: 1rem;
	color: rgba(255, 255, 255, 0.65);
	line-height: 1.8;
	font-style: italic;
	margin: 0 0 44px;
}

.brand-features {
	list-style: none;
	padding: 0;
	margin: 0;
}

.brand-features li {
	display: flex;
	align-items: center;
	gap: 10px;
	color: rgba(255, 255, 255, 0.78);
	font-size: 0.82rem;
	letter-spacing: 0.3px;
	margin-bottom: 14px;
}

.brand-footer {
	padding-top: 44px;
}

.brand-footer-bar {
	width: 100%;
	height: 1px;
	background: rgba(255, 255, 255, 0.10);
	margin-bottom: 16px;
}

.brand-footer-text {
	font-size: 0.68rem;
	color: rgba(255, 255, 255, 0.30);
	letter-spacing: 3.5px;
	text-transform: uppercase;
	margin: 0;
}

/* ─── Panel droit : Formulaire ─── */

.form-panel {
	flex: 1;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow-y: auto;
}

.form-panel-inner {
	width: 100%;
	max-width: 400px;
	padding: 48px 36px;
}

.form-logo-wrap {
	text-align: center;
	margin-bottom: 36px;
}

.form-logo {
	width: 66px;
}

/* ─── Responsive ─── */

@media (max-width: 960px) {
	.brand-panel {
		display: none;
	}

	.form-panel-inner {
		max-width: 480px;
		padding: 40px 24px;
	}
}
</style>
